/**
 * StoreBadges — les badges OFFICIELS des deux boutiques (source unique, 10/10/2026).
 *
 * Artwork non modifié, hauteur visible 40 px (règles Apple et Google — l'origine
 * des deux fichiers est documentée dans utils/storeLinks.js). Utilisé par
 * l'invitation aux applis (PWAInstallPrompt) ET par le pied de page (Layout) :
 * un seul endroit à corriger si une URL ou un fichier change.
 */
import React from "react";
import { APP_STORE_URL, PLAY_STORE_URL } from "../utils/storeLinks";

export const BadgeAppStore = () => (
  <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" data-testid="store-badge-apple"
     className="inline-flex items-center">
    {/* Artwork Apple officiel, non modifié, hauteur ≥ 40 px (règles Apple). */}
    <img src="/badges/app-store.svg" alt="Télécharger dans l'App Store" width={120} height={40} className="h-10 w-auto" />
  </a>
);

export const BadgeGooglePlay = () => (
  <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" data-testid="store-badge-google"
     className="inline-flex items-center">
    {/* Artwork Google officiel : le PNG inclut sa marge (192 px utiles sur 250).
        À 52 px de haut, la partie visible mesure 40 px, comme le badge Apple. */}
    <img src="/badges/google-play-fr.png" alt="Disponible sur Google Play" width={134} height={52} className="h-[52px] w-auto -my-1.5" />
  </a>
);

/** Les deux badges côte à côte (pied de page, pages d'information). */
export const StoreBadgesRow = ({ className = "" }) => (
  <div className={`flex flex-wrap items-center justify-center gap-3 ${className}`.trim()}
       data-testid="store-badges" role="group" aria-label="Télécharger l'application Gively">
    <BadgeAppStore />
    <BadgeGooglePlay />
  </div>
);
